import React from "react";
import { Typography, Box } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  subtitle: {
    paddingTop: theme.spacing(4),
    marginBottom: theme.spacing(2)
  },
  supportInfo: {
    marginTop: theme.spacing(3)
  },
  divider: {
    width: 1,
    backgroundColor: theme.palette.secondary[300],
    margin: theme.spacing(3, 1, 0, 1),
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  link: {
    color: theme.palette.primary.main,
    cursor: "pointer"
  },
  message: {
    "& a": {
      color: theme.palette.primary.main
    }
  }
}));

const SupportTab = ({ info }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div>
      {info.header && (
        <Typography className={classes.subtitle} variant="h5">
          {info.header}
        </Typography>
      )}
      {info.message && (
        <Typography
          className={classes.message}
          component="div"
          variant="body1"
          color="textSecondary"
        >
          <div dangerouslySetInnerHTML={{ __html: info.message }} />
        </Typography>
      )}
      <Box
        flexDirection={{ xs: "column", sm: "row" }}
        display="flex"
        justifyContent="space-between"
      >
        {info.email && (
          <>
            <div className={classes.supportInfo}>
              <Typography variant="subtitle1">{t("support.email")}</Typography>
              <Typography color="textSecondary">
                <span className={classes.link}>{info.email}</span>
              </Typography>
            </div>
            <div className={classes.divider} />
          </>
        )}
        {info.operationHours && (
          <>
            <div className={classes.supportInfo}>
              <Typography variant="subtitle1">{t("support.hours")}</Typography>
              <Typography color="textSecondary">
                {info.operationHours}
              </Typography>
            </div>
          </>
        )}
        {info.phoneNumber && (
          <>
            <div className={classes.divider} />
            <div className={classes.supportInfo}>
              <Typography variant="subtitle1">{t("support.phone")}</Typography>
              <Typography color="textSecondary">{info.phoneNumber}</Typography>
            </div>
          </>
        )}
        <div />
      </Box>
    </div>
  );
};

export default SupportTab;
